// extracted by mini-css-extract-plugin
module.exports = {"content":"WordPopover_content__Qf_Ne","trigger":"WordPopover_trigger__aNSSt"};